module.exports = __webpack_public_path__ + "static/media/Icon-1.02db0d4b.png";